import { gql } from "graphql-tag"; // NOSONAR
import { environment } from "src/environments/environment";

export class Constants {
	public navLinkItems = {
		tproms: { displayName: 'Home', route: 'dashboard' },
		user: {
			person: { displayName: 'MAX JONES', icon: 'person' },
			id: { displayName: '10034' },
			profile: { displayName: 'ADMIN' },
			help: { displayName: 'HELP', icon: 'help' },
			settings: { displayName: 'SETTINGS', icon: 'settings' },
			logout: { displayName: 'LOGOUT', icon: 'logout' }
		},
    planning: {
			alarms: { displayName: 'ALARMS', url: environment.ALARMS },
			allo: { displayName: 'ALLO', url: environment.ALLO },
			companyInfoChange: { displayName: 'company Info Change', url: 'mshell/maintenance/company-info-change' },
			costPlanning: { displayName: 'COST PLANNING', url: environment.COST_PLANNING },
			eboi: { displayName: 'EBOI', url: environment.EBOI },
			exports: { displayName: 'EXPORTS', url: environment.EXPORT },
			forecastAdmin: { displayName: 'Forecast Admin Dashboard (Import/Export dashboard)', url: environment.FORECAST_ADMIN_DASHBOARD },
			fto: { displayName: 'FTOs', url: 'opershell/operations/fto' },
			group1: { displayName: 'GROUP I', url: environment.GROUPI },
			dashboard: { displayName: 'Import/Export', url: 'opershell/operations/dashboard' },
			masterDock: { displayName: 'Master Dock', url: 'mshell/maintenance/master-dock' },
			regionTargets: { displayName: 'Region Targets', url: 'opershell/operations/region-targets' },
			scnc: { displayName: 'SCNC', url: 'opershell/operations/scnc' },
			taskManager: { displayName: 'TASK MANAGER', url: environment.TASK_MANAGER },
			tlmsSend: { displayName: 'TLMS Send', url: environment.TLMS_SEND },
			delayedDispatch: { displayName: 'Delayed Dispatch', url: environment.DD },
		},
		operations: {
			aet: { displayName: 'AET', url: environment.AET },
			companyInfo: { displayName: 'company Info', url: 'mshell/maintenance/company-info' },
			lpBilling: { displayName: 'LP Billing', url: 'bshell', fga: ['Billing Master', 'Logistics Cost Management', 'Cost Master', 'DRC', 'General Costs', 'Expedite Costs', 'Surcharges', 'LP Invoice', 'Billing Summary'] },
			trailerLoadDiagrams: { displayName: 'Trailer Load Diagrams', url: environment.TLD },
			uxmxroutes: { displayName: 'US MX Routes', url: 'opershell/operations/uxmxroutes' },
			wtResolution: { displayName: 'WT Resolution ', url: 'mshell/maintenance/window-times', fga: ['Window Times', 'TLMS Send'] }
		},
		reporting: {
			scheduleDashboard: { displayName: 'Schedule Dashboard', url: environment.SCHEDULE_DASHBOARD },
			reports: { displayName: 'Reports', url: environment.REPORTS },
		},
		maintenance: {
			notificationGroup: { displayName: 'Notification Group', url: 'admin/notification-group' },
			permissionManagement: { displayName: 'Permission Management', url: 'mshell/apm/permission-management/user-management' },
			returnsReload: { displayName: 'Returns Reload', url: 'mshell/maintenance/returns-reload', fga: ['Returns Reload'] },
		}
	}

	templateInfomation = [
		{ "Field": "D-Day", "Rules": "Must be a positive or negative whole number" },
		{ "Field": "Due Time", "Rules": "String in the format of HH:mi" },
		{ "Field": "Sequence", "Rules": "A positive number between 0 and 255" },
		{ "Field": "Override Assignment", "Rules": "Only for Contingency Templates to override the Primary and Secondary Users and/or Regions" }
	];

	public liosMenuItems = [
		{ displayName: 'COMPANY INFORMATION' },
		{ displayName: 'MASTER DATA' },
		{ displayName: 'IMPORT/EXPORT' },
		{ displayName: 'WINDOW TIMES' },
		{ displayName: 'REPORTING' },
		{ displayName: 'ADMIN' },
		{ displayName: 'BILLING' },
		{ displayName: 'DELAYED DISPATCH' },
		{ displayName: 'AET' },
		{ displayName: 'TSCS' },
		{ displayName: 'TPT' },
		{ displayName: 'PLANNING' }
	];

	constructor() { }
}

export const generateRandomString = (length = 6): string => {
		const chars =
			'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
		let result = '';
		for (let i = 0; i < length; i++) {
			result += chars.charAt(Math.floor(Math.random() * chars.length));
		}
		return result;
	};

export const	FILE_UPLOAD_TIMEOUT = 300000;

export const GET_FGA_USER_DATA = gql`
  query {
    listUsers {
      userId
      userPrincipalName
      externalUserId
      email
      firstName
      middleName
      lastName
      displayName
      workdayId
      userActiveFlag
      recordCreatedDate
      recordLastUpdatedDate
      commonUserAttributes {
        type
        title
        companyName
        alternateCompanyName
        companyCode
        plantName
        department
        supplierNumber
      }
      applicationUserAttribute {
        applicationId
        externalApplicationId
        userAttributes {
          key
          value
        }
      }
      roles
    }
  }
`;

export const GET_FGA_AM_USER_DATA = gql `query ListUsersByFilters(
  $firstName: String
  $lastName: String
  $middleName: String
  $userPrincipalName: String
  $email: String
  $roles: [String!]
) {
  listUsersByFilters(
    firstName: $firstName
    lastName: $lastName
    middleName: $middleName
    userPrincipalName: $userPrincipalName
    email: $email
    roles: $roles
  ) {
    userId
    displayName
    firstName
    lastName
    email
    userPrincipalName
    roles
    __typename
  }
}
`
